import { Box, Button, makeStyles } from '@material-ui/core'

import { useState } from 'react'

import { GRAY_COLORS } from 'asterX-UI'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'

import ActivityFeed from 'components/Mobile/WorkListView/ActivityFeed'
import { creationTypes } from 'components/Rop/RopWLFilter/const'

import { colorStatusesByCode, OKTELL, SMM } from 'constants/deals'

import { useAuthStore } from 'context/AuthStore'
import { useWorkListStoreManager } from 'context/HomeStore/Manager/WorkListsProvider/WorkListProvider.manager'
import { useWorkListViewMnStore } from 'context/WorkListViewStore/Manager/WorkListViewStore.manager'

import { SalesService } from 'lib/api'
import { useResErrors, useRoutes } from 'hooks'
import { SELECTION_STEP_PATH_LOADED } from 'routes/constants.routes'

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 8,
    display: 'flex',
    justifyContent: 'space-between',
    padding: 4,
    gap: 8
  },
  idWl: {
    color: GRAY_COLORS[800],
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    fontFamily: 'Inter'
  },
  statuses: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    alignItems: 'end',
    cursor: 'pointer'
  }
}))

const Header = ({ wlId, status, carfinStatus, globalId }) => {
  const classes = useStyles()
  const { workListStore } = useWorkListStoreManager()
  const { authStore } = useAuthStore()
  const { standardCheck } = useResErrors()
  const { goTo } = useRoutes()

  const [openFeed, setOpenFeed] = useState(false)

  const isThisTab = checkedTab => checkedTab === workListStore.selectedTab

  const [isAssignButtonVisible, setIsAssignButtonVisible] = useState(
    isThisTab(SMM) || isThisTab(OKTELL)
  )

  const { workListViewStore } = useWorkListViewMnStore()

  const assignToManager = async () => {
    if (isThisTab(SMM) || isThisTab(OKTELL)) {
      const data = {
        assignTo: authStore.user.data.username,
        assignToFullName: `${authStore.user.data.firstName} ${authStore.user.data.lastName}`,
        branchCode: authStore.user.data.branch.code,
        id: workListViewStore.sale.id
      }

      const response = await SalesService.setAssignTo(data)

      standardCheck(
        response,
        () => {
          setIsAssignButtonVisible(false)
          goTo(SELECTION_STEP_PATH_LOADED(workListViewStore.sale.id)[0])
        },
        () => {}
      )
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.idWl}>{`РЛ ${
        globalId ? `${globalId}` : ''
      }`}</div>

      <Box className={classes.statuses}>
        <ChipStandard
          {...colorStatusesByCode(status?.code)}
          onClick={() => setOpenFeed(true)}
        >
          {status?.name}
        </ChipStandard>

        {carfinStatus?.name && (
          <ChipStandard
            {...{
              color: 'rgb(65, 111, 198)',
              backgroundColor: 'rgb(245, 246, 255)'
            }}
            onClick={() => setOpenFeed(true)}
          >
            ФС: {carfinStatus?.name}
          </ChipStandard>
        )}

        <ChipStandard>
          Тип создания:{' '}
          {creationTypes.find(
            creationType =>
              creationType.value === workListViewStore?.sale?.creationType
          )?.name || '-'}
        </ChipStandard>

        <ChipStandard>
          Вид создания: {workListViewStore?.sale?.callResult || '-'}
        </ChipStandard>

        <ChipStandard>
          Номер обращения: {workListViewStore?.sale?.contactId}
        </ChipStandard>

        {isAssignButtonVisible && (
          <Button color="primary" variant="contained" onClick={assignToManager}>
            Взять в работу
          </Button>
        )}
      </Box>

      <ActivityFeed
        id={wlId}
        open={openFeed}
        onClose={() => setOpenFeed(false)}
      />
    </div>
  )
}

export default Header
